import FilterDrawer from 'components/Assignments/FilterDrawer';
import { useApp } from 'contexts/app';
import { useAuth } from 'contexts/auth';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/StudentAssignments/PageProvider';
import Desktop from 'pages/StudentAssignments/desktop';
import Mobile from 'pages/StudentAssignments/mobile';
import Tablet from 'pages/StudentAssignments/tablet';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import assignmentService from 'services/assignment';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading, assignments: allAssignments } = useApp();
    const { auth } = useAuth();
    const history = useHistory();
    const { device } = useViewport();

    const { filters, setFilters, resetFilters } = useContext(PageContext);

    const [batch, setBatch] = useState(null);
    const [feedback, setFeedback] = useState(null);

    const getFilterCount = (filters) => {
        let count = 0;
        if (filters.sort !== 'none') count++;
        return count;
    };

    const onClick = ({ id }) => {
        history.push(`/assignments/${id}`);
    };

    const onClickGetFeedback = ({ id }) => {
        history.push(`/assignments/${id}`);
    };

    const onClickViewFeedback = ({ id }) => {
        history.push(`/assignments/${id}`);
    };

    useEffect(() => {
        if (!allAssignments) return;
        const assignments = allAssignments?.filter(
            ({ ai_student_feedback_enabled, is_draft }) => ai_student_feedback_enabled && !is_draft
        );
        if (assignments?.length) {
            assignments.forEach(async ({ id }) => {
                const batch = await assignmentService.getAssignmentBatch(
                    id,
                    JSON.stringify({
                        is_finished: false,
                        owner_account_id: auth.id,
                    })
                );
                const feedback = await assignmentService.getAssignmentFeedback(
                    id,
                    JSON.stringify({ owner_account_id: auth.id })
                );
                setBatch((current) => ({ ...(current || {}), [id]: batch }));
                setFeedback((current) => ({ ...(current || {}), [id]: feedback }));
            });
        } else {
            setBatch({});
            setFeedback({});
        }
    }, [allAssignments, auth.id]);

    const props = {
        batch,
        feedback,
        setFeedback,
        filters,
        setFilters,
        getFilterCount,
        onClick,
        onClickGetFeedback,
        onClickViewFeedback,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return isLoading || !feedback ? (
        <Loading />
    ) : (
        <>
            {renderResponsiveLayout(device)}
            <FilterDrawer filters={filters} setFilters={setFilters} resetFilters={resetFilters} />
        </>
    );
};

export default PageLayout;
